import React, { Component } from "react";
import DetailWindow from "./detailWindow";

class MatBtn extends Component {
	state = {
		hideDetail: true,
	};

	handleHideDetail = (value) => {
		this.setState({ hideDetail: value });
	};

	render() {
		let { choise, matBtnCMD } = this.props;
		return (
			<React.Fragment>
				<div className="matBtn">
					<img
						className="matBtn-image"
						src={choise.image_url}
						onClick={() => matBtnCMD(choise)}
					/>
					<span className="matBtn-price">
						{choise.surcharge.toLocaleString("de-DE", {
							style: "currency",
							currency: "EUR",
							maximumFractionDigits: 2,
						})}
					</span>
					<div className="matBtn-name" onClick={() => matBtnCMD(choise)}>
						<span>{choise.label.de}</span>
					</div>
					<a
						className="matBtn-detail"
						onClick={() => this.handleHideDetail(false)}
					>
						Details
					</a>
				</div>
				<DetailWindow
					choise={choise}
					isHide={this.state.hideDetail}
					toggleShow={this.handleHideDetail}
				/>
			</React.Fragment>
		);
	}
}

export default MatBtn;
